"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const DoctorNurseGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "DOCTOR-NURSE-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.815 20.424a.5.5 0 0 1 .09.992l-.09.008H.985a.5.5 0 0 1-.09-.992l.09-.008h21.83M7.801 11.5c1.81 0 3.338 1.399 4.09 3.422.725-1.952 2.175-3.324 3.902-3.417l.188-.005h2.726c2.58 0 4.59 2.845 4.59 6.288a.5.5 0 0 1-1 0c0-2.866-1.56-5.154-3.425-5.282l-.165-.006H15.98c-1.938 0-3.59 2.338-3.59 5.288a.5.5 0 0 1-.41.491l-.09.009a.5.5 0 0 1-.5-.5c0-2.866-1.559-5.154-3.424-5.282L7.8 12.5H5.075c-1.938 0-3.59 2.338-3.59 5.288a.5.5 0 0 1-1 0c0-3.36 1.914-6.149 4.402-6.283l.188-.005h2.726m3.052-8.093a.5.5 0 0 1 .14.625l-.049.076-1.72 2.242a3.254 3.254 0 1 1-5.736-.008L1.769 4.098a.5.5 0 0 1 .093-.7 7.386 7.386 0 0 1 8.99.009Zm9.616 2.695a3.455 3.455 0 1 1-6.65 1.377l.002-.023a3.448 3.448 0 0 1 .264-1.354.5.5 0 0 1 .924.383 2.457 2.457 0 0 0-.147.494h4.83a2.457 2.457 0 0 0-.147-.494.5.5 0 0 1 .924-.383M6.354 5.631a2.254 2.254 0 1 0 0 4.509 2.254 2.254 0 0 0 0-4.509M19.669 7.98h-4.784a2.455 2.455 0 0 0 4.784 0m-2.394-4.8a1.767 1.767 0 1 1 0 3.533 1.767 1.767 0 0 1 0-3.534m0 1a.767.767 0 1 0 0 1.533.767.767 0 0 0 0-1.534M2.91 3.882l-.031.02L4.118 5.52a3.243 3.243 0 0 1 2.236-.889c.868 0 1.658.34 2.241.895l1.239-1.615-.03-.02a6.387 6.387 0 0 0-6.894-.008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.244 14.128a.5.5 0 0 1 .492.41l.008.09v.908l.91.001a.5.5 0 0 1 .09.992l-.09.008h-.91v.91a.5.5 0 0 1-.992.089l-.008-.09v-.91l-.908.001a.5.5 0 0 1-.09-.992l.09-.008h.908v-.909a.5.5 0 0 1 .5-.5m-10.733 0a.5.5 0 0 1 .492.41l.008.09v.908l.91.001a.5.5 0 0 1 .09.992l-.09.008h-.91v.91a.5.5 0 0 1-.991.089l-.009-.09v-.91l-.908.001a.5.5 0 0 1-.09-.992l.09-.008h.908v-.909a.5.5 0 0 1 .5-.5Z"
  })));
};
DoctorNurseGraphicIcon.displayName = "DoctorNurseGraphicIcon";
DoctorNurseGraphicIcon.iconName = "DoctorNurse";
export default DoctorNurseGraphicIcon;